import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/incoming_invoices',
    name: 'IncomingInvoices',
    component: {
      name: 'AdminIncomingInvoice',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'incoming_invoice',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminIncomingInvoiceIndex',
        component: () => import('../views/IncomingInvoiceAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminIncomingInvoiceNew',
        component: () => import('../views/IncomingInvoiceAdminInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminIncomingInvoiceIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminIncomingInvoiceShow',
        component: () => import('../views/IncomingInvoiceAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminIncomingInvoiceIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: 'purchase_mutations',
            name: 'AdminIncomingInvoicePurchaseMutations',
            component: () =>
              import(
                '../views/purchaseMutation/IncomingInvoicePurchaseMutations.vue'
              ),
            meta: {
              backRoute: { name: 'AdminIncomingInvoiceIndex' },
              resource: 'purchase_mutation',
            },
          },
          {
            path: '',
            name: 'AdminIncomingInvoiceDetails',
            component: () => import('../views/IncomingInvoiceAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminIncomingInvoiceIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminIncomingInvoiceEdit',
            component: () => import('../views/IncomingInvoiceAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminIncomingInvoiceDetails' },
            },
          },
          {
            path: 'send',
            name: 'AdminIncomingInvoiceSendEmail',
            component: () => import('../views/IncomingInvoiceSendEmail.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminIncomingInvoiceIndex' },
              customName: 'general.send_email_template',
            },
          },
          {
            path: 'phases',
            name: 'AdminIncomingInvoicePhases',
            component: () => import('../views/IncomingInvoicePhases.vue'),
            meta: {
              backRoute: { name: 'AdminIncomingInvoiceIndex' },
              resource: 'phase',
            },
          },
          {
            path: 'processed_document_connections',
            name: 'AdminProcessedDocumentConnections',
            component: {
              name: 'AdminProcessedDocumentConnection',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminIncomingInvoiceIndex' },
              resource: 'processed_document_connection',
            },
            children: [
              {
                path: '',
                name: 'AdminIncomingInvoiceProcessedDocumentConnections',
                component: () =>
                  import(
                    '../views/processedDocumentConnection/ProcessedDocumentConnectionIndex.vue'
                  ),
                meta: {
                  backRoute: { name: 'AdminIncomingInvoiceIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminProcessedDocumentConnectionNew',
                component: () =>
                  import(
                    '../views/processedDocumentConnection/ProcessedDocumentConnectionInput.vue'
                  ),
                meta: {
                  action: 'new',
                  backRoute: {
                    name: 'AdminIncomingInvoiceProcessedDocumentConnections',
                  },
                },
              },
              {
                path: ':processedDocumentConnectionId(\\d+)',
                name: 'AdminProcessedDocumentConnectionShow',
                component: () =>
                  import(
                    '../views/processedDocumentConnection/ProcessedDocumentConnectionShow.vue'
                  ),
                meta: {
                  backRoute: {
                    name: 'AdminIncomingInvoiceProcessedDocumentConnections',
                  },
                  tArgs: route => ({
                    name: route.params?.processedDocumentConnectionId,
                  }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminProcessedDocumentConnectionDetails',
                    component: () =>
                      import(
                        '../views/processedDocumentConnection/ProcessedDocumentConnectionDetails.vue'
                      ),
                    meta: {
                      backRoute: {
                        name:
                          'AdminIncomingInvoiceProcessedDocumentConnections',
                      },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminProcessedDocumentConnectionEdit',
                    component: () =>
                      import(
                        '../views/processedDocumentConnection/ProcessedDocumentConnectionInput.vue'
                      ),
                    meta: {
                      action: 'edit',
                      backRoute: {
                        name: 'AdminProcessedDocumentConnectionDetails',
                      },
                    },
                  },
                ],
              },
            ],
          },
          {
            path: 'logs',
            name: 'AdminIncomingInvoiceLogs',
            component: () => import('../views/IncomingInvoiceLogs.vue'),
            meta: {
              backRoute: { name: 'AdminIncomingInvoiceIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ],
  },
  {
    path: 'admin/purchase_mutations',
    name: 'PurchaseMutations',
    component: {
      name: 'AdminPurchaseMutation',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'purchase_mutation',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdmiPurchaseMutationIndex',
        component: () =>
          import('../views/purchaseMutation/PurchaseMutationAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminPurchaseMutationShow',
        component: () =>
          import('../views/purchaseMutation/PurchaseMutationAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminPurchaseMutationIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminPurchaseMutationDetails',
            component: () =>
              import(
                '../views/purchaseMutation/PurchaseMutationAdminDetails.vue'
              ),
            meta: {
              backRoute: { name: 'AdminPurchaseMutationIndex' },
            },
          },
        ],
      },
    ],
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));
